import { Card, CardContent } from "@/components/ui/card";
import { RisorseGruppo, StimeDichiarate } from "./RisorseGruppo";
import { STATO_ANALISI, dec, eur, pill } from "./format";

const RIEPILOGO = [["costo_mdo", "Manodopera"], ["costo_materiali", "Materiali"], ["costo_noli", "Noli e attrezzature"],
  ["spese_generali", "Spese generali"], ["utile", "Utile d'impresa"], ["totale", "Totale = prezzo di computo"]];

const Fattore = ({ label, v, testid }) => {
  const n = v === null ? null : Number(v);
  const cls = n !== null && n < 1 ? "text-rose-700" : "text-slate-800 dark:text-slate-200";
  return <span>{label}: <b className={`font-mono ${cls}`} data-testid={testid}>{n === null ? "—" : `×${dec(v, 3, 4)}`}</b></span>;
};

const Testata = ({ a }) => {
  const st = STATO_ANALISI[a.stato] || STATO_ANALISI.stima;
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <span className={`${pill} ${st.cls}`} data-testid="analisi-stato">{st.label}{a.livello ? ` · ${a.livello}` : ""}</span>
        {a.ridotta && <span className={`${pill} bg-rose-50 text-rose-700 border-rose-200`} data-testid="analisi-ridotta-badge">Analisi ridotta nel file</span>}
        {a.codice && <span className="font-mono text-xs text-slate-500">{a.codice}</span>}
      </div>
      {a.descrizione && <p className="text-sm text-slate-700 dark:text-slate-300">{a.descrizione}</p>}
      <div className="flex flex-wrap gap-x-6 gap-y-1 text-xs text-slate-500">
        <span>U.M.: <b className="text-slate-800 dark:text-slate-200">{a.um || "—"}</b></span>
        <span>Prezzo dichiarato: <b className="font-mono text-slate-800 dark:text-slate-200" data-testid="analisi-prezzo">{eur(a.prezzo_dichiarato, 4)}</b></span>
        <Fattore label="Fattore tempi manodopera" v={a.fattore_tempi_mdo} testid="analisi-fattore-mdo" />
        <Fattore label="Fattore prezzi materiali/noli" v={a.fattore_prezzi_mat_noli} testid="analisi-fattore-mat" />
        <span>Ore previste: <b className="font-mono text-slate-800 dark:text-slate-200" data-testid="analisi-ore">{a.ore_totali === null ? "—" : `${dec(a.ore_totali, 2, 3)} h`}</b></span>
      </div>
      {a.etichetta_ore && <p className="text-[11px] text-slate-500 italic">{a.etichetta_ore}</p>}
    </div>
  );
};

const Riepilogo = ({ totali }) => (
  <div className="grid grid-cols-2 lg:grid-cols-3 gap-2" data-testid="analisi-riepilogo">
    {RIEPILOGO.map(([k, l]) => {
      const t = totali[k];
      return (
        <div key={k} className={`rounded-md border p-3 ${k === "totale" ? "border-amber-300 bg-amber-50/60" : ""}`} data-testid={`analisi-tot-${k}`}>
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{t?.etichetta || l}</div>
          <div className="font-mono text-sm mt-1">{t ? eur(t.importo_um, 4) : "—"} <span className="text-[10px] text-slate-400">/ U.M.</span></div>
          <div className="font-mono text-xs text-slate-500">{t ? eur(t.importo_totale) : "—"} voce</div>
        </div>
      );
    })}
  </div>
);

export const AnalisiPrevista = ({ analisi, eff, onRegistra }) => {
  if (!analisi) return <Card><CardContent className="p-6 text-sm text-slate-500" data-testid="analisi-assente">Nessuna analisi importata per questa voce.</CardContent></Card>;
  const isStima = analisi.stato === "stima";
  return (
    <Card data-testid="excel-analisi-prevista"><CardContent className="p-4 sm:p-6 space-y-5">
      <div className="text-xs uppercase tracking-widest text-amber-600 font-semibold">Analisi prezzi prevista (dall'Excel, non ricalcolata)</div>
      <Testata a={analisi} />
      {isStima ? <><StimeDichiarate stime={analisi.stime} />{onRegistra && <p className="text-xs text-slate-500">Le registrazioni effettive di questa voce si inseriscono dalla scheda «Registrazioni effettive».</p>}</> : (
        <div className="space-y-3">{analisi.gruppi.map((g) => <RisorseGruppo key={g.tipo} gruppo={g} eff={eff} onRegistra={onRegistra} />)}</div>
      )}
      <Riepilogo totali={analisi.totali} />
      {(analisi.note?.testata || analisi.note?.totale) && (
        <div className="text-xs text-slate-500 space-y-0.5" data-testid="analisi-note">
          {analisi.note.testata && <p>Nota analisi: {analisi.note.testata}</p>}
          {analisi.note.totale && <p>Nota totale: {analisi.note.totale}</p>}
        </div>
      )}
      <p className="text-[11px] text-slate-400">Fonte: foglio «{analisi.fonte?.foglio}», riga {analisi.fonte?.riga_testata}.</p>
    </CardContent></Card>
  );
};
